/* jshint esversion: 11 */
/* jshint ignore:start */

import React, { useContext, useState } from "react";
import axios from "axios";
import Usericon from "../../Icon/user.svg";
import Emailicon from "../../Icon/email.svg";
import Callicon from "../../Icon/call.svg";
import { MyContext } from "../../Context/MyProvider";
import { showTost } from "../../showTost";
import { useNavigate } from "react-router-dom";
import { useTranslation } from "react-i18next";
import {
  SHOP_AUTH_ENDPOINTS,
  closeSsoPopupWindow,
  getShopApiTokenFromResponse,
  openSsoPopupWindow,
  requestSsoCode,
  consumeLoginRedirectPath,
  storeAuthResponse,
} from "../../utils/auth";

const Signup = () => {
  const { t } = useTranslation();
  const { setIsSignUpShow, setIsLogin } = useContext(MyContext);
  const navigate = useNavigate();
  const mobile = localStorage.getItem("mobile");

  const [signUpData, setSignUpData] = useState({
    name: "",
    email: "",
    password: "123456", // 🔒 FIXED PASSWORD
    refrenceCode: "",
  });

  // ================= SIGN UP =================
  const handleSignUp = async () => {
    if (!signUpData.name || !signUpData.email) {
      showTost(t("Please fill all details"), "error");
      return;
    }

    if (mobile.length !== 10) {
      showTost(t("Enter valid 10 digit mobile number"), "error");
      return;
    }

    const formData = new FormData();
    formData.append("name", signUpData.name);
    formData.append("password", "123456"); // 🔒 FIXED
    formData.append("mobileNo", mobile);
    formData.append("emailId", signUpData.email);
    formData.append("refrenceCode", signUpData.refrenceCode || "");

    const ssoPopupWindow = openSsoPopupWindow();

    try {
      const res = await axios.post(
        SHOP_AUTH_ENDPOINTS.register,
        formData,
        { headers: { "Content-Type": "multipart/form-data" } }
      );

      if (res.data?.success === true) {
        showTost(res.data.message, "success");

        const apiToken = getShopApiTokenFromResponse(res.data);

        storeAuthResponse(res.data);

        setIsLogin(true);
        setIsSignUpShow(false);
        requestSsoCode(apiToken, ssoPopupWindow)
          .catch(() => {
            closeSsoPopupWindow(ssoPopupWindow);
          });
        navigate(consumeLoginRedirectPath());
      } else {
        closeSsoPopupWindow(ssoPopupWindow);
        showTost(res.data?.message || "Registration failed", "error");
      }
    } catch (error) {
      closeSsoPopupWindow(ssoPopupWindow);
      showTost(error.message, "error");
    }
  };

  return (
    <div className="signup-box">
      <div className="py-[10px] px-[20px]">
        <h1 className="text-[24px] font-[600]">{t("Sign Up")}</h1>

        <form onSubmit={(e) => {
          e.preventDefault();
          handleSignUp();
        }}>
          {/* NAME */}
          <div className="login-input mt-[20px] focus-within:border-[#d2a347] focus-within:border">
            <img src={Usericon} alt="" className="w-[25px]" />
            <input
              type="text"
              placeholder={t("Full Name")}
              className="w-full bg-transparent outline-none px-[10px] text-white"
              onChange={(e) =>
                setSignUpData({ ...signUpData, name: e.target.value })
              }
            />
          </div>

          {/* EMAIL */}
          <div className="login-input mt-[20px] focus-within:border-[#d2a347] focus-within:border">
            <img src={Emailicon} alt="" className="w-[25px]" />
            <input
              type="email"
              placeholder={t("Email")}
              className="w-full bg-transparent outline-none px-[10px] text-white"
              onChange={(e) =>
                setSignUpData({ ...signUpData, email: e.target.value })
              }
            />
          </div>

          {/* MOBILE (+91 FIXED) */}
          <div className="login-input mt-[20px] flex items-center focus-within:border-[#0000ffb7] focus-within:border">
            <img src={Callicon} alt="" className="w-[25px]" />
            <span className="ml-2 mr-2 font-medium text-white">+91</span>
            <input
              type="tel"
              placeholder={t("Enter mobile number")}
              maxLength={10}
              value={mobile}
              disabled
              className="w-full bg-transparent outline-none text-white"
            />
          </div>

          <h1 className="mt-[10px] font-[600] text-[15px] text-white">
            {t("By signing up, you agree to our")}{" "}
            <span className="text-[#a33cff]">
              {t("Terms of Service")}
            </span>{" "}
            {t("and")}{" "}
            <span className="text-[#a33cff]">
              {t("Privacy Policy")}
            </span>
          </h1>

          <button type="submit" className="button mt-[10px]">
            {t("Sign Up")}
          </button>
        </form>
      </div>
    </div>
  );
};

export default Signup;

/* jshint ignore:end */
